import MaterialCircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';

export function CircularProgress(props: CircularProgressProps) {
    return (
        <MaterialCircularProgress
            data-testid={'CircularProgress-container'}
            {...props}
        />
    );
}

export default CircularProgress;
